export default function auth ({ next, store }){
    if(!store.state.user.loggedIn){
        console.log("You must be logged in")
        return next({
           name: 'login'
        })
    }
   
    return next()
   }